import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-16 md:py-24 bg-gradient-to-b from-[#D8F3DC] to-[#95D5B2]" data-id="element-88">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-90">
          <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-6 shadow-md" data-id="element-91">
            <SparklesIcon className="w-5 h-5 text-[#2D6A4F]" data-id="element-92" />
            <span className="font-medium text-[#2D6A4F]" data-id="element-93">
              El Mecanismo Único
            </span>
          </div>

          <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#2D6A4F] mb-6" data-id="element-94">
            El Sistema de las 3 Macetas
          </h2>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-95">
            <p className="text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-96">
              Es un método de ingeniería urbana diseñado para la vida moderna.
              Clasificamos tu balcón en 3 zonas de luz real y asignamos solo
              'especies velocistas' (plantas que crecen en 30 días o menos).
              Olvida esperar meses para ver un brote; aquí trabajamos con
              rábano, rúcula y lechuga 'baby' para que cenes lo que siembras
              antes de que termine el mes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}